// src/CustomNode.js
import React from 'react';
import { Handle } from 'reactflow';

// Optimierte CustomNode-Komponente mit React.memo
const CustomNode = React.memo(({ data }) => {
  return (
    <div
      style={{
        padding: 10,
        borderRadius: 5,
        border: '1px solid #333',
        background: data.style.background,
        color: data.style.color,
        minWidth: 150,
        maxWidth: data.style.width || 300, // Dynamische Breite
        wordWrap: 'break-word', // Text umbrechen
        boxSizing: 'border-box', // Stellen Sie sicher, dass Padding und Border in der Breite enthalten sind
      }}
    >
      {data.label}
      <Handle type="source" position="right" />
      <Handle type="target" position="left" />
    </div>
  );
});

export default CustomNode;